export default __webpack_public_path__ + "static/media/pearl-jam-live.5535656c.jpg";